import React from 'react';
import { Box, Button, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { LuLockOpen } from 'react-icons/lu';
import { formatSharedBundleAccessLabel, PRO_SUBSCRIPTION_SHORT_COPY } from '../proSubscriptionCopy.ts';

interface PropertySelectorLockedSubscribeCardProps {
	lockedCount: number;
	onSubscribe: () => void;
	isLoading?: boolean;
}

const PropertySelectorLockedSubscribeCard: React.FC<PropertySelectorLockedSubscribeCardProps> = (props) => {
	const { lockedCount, onSubscribe, isLoading } = props;
	const label = formatSharedBundleAccessLabel(lockedCount);

	return (
		<Box w="full" mt={1} mb={1} p={3} bg="surface.subtle" borderRadius="3xl">
			<HStack align="flex-start" gap={2} mb={3}>
				<Icon as={LuLockOpen} boxSize={4} color="fg.muted" mt="2px" flexShrink={0} />
				<VStack align="start" gap={0.5} minW={0} flex={1}>
					<Text textStyle="body.sm">{label}</Text>
					<Text textStyle="micro" color="fg.muted" lineHeight="1.4">
						{PRO_SUBSCRIPTION_SHORT_COPY}
					</Text>
				</VStack>
			</HStack>
			<Button
				colorPalette="brand"
				size="sm"
				w="full"
				borderRadius="full"
				onClick={onSubscribe}
				loading={isLoading}
			>
				Subscribe
			</Button>
		</Box>
	);
};

export default PropertySelectorLockedSubscribeCard;
